import { useMutation, useQuery } from 'react-query';

import { ApiErrors } from '@common/api-request';

import { createAffiliatePdpShareLink, getAffiliateUserStatus } from '../graphql/affiliate.2';
import { CreateAffiliatePdpShareLinkInput } from '../graphql/affiliate_types.2';

interface Props {
  enabled: boolean;
}
export const useAffiliateShareDeepLink = ({ enabled }: Props) => {
  const { data: user_account_status, isLoading: isAffiliateStatusLoading } = useQuery({
    queryKey: ['getAffiliateUserStatus'],
    queryFn: () =>
      getAffiliateUserStatus(undefined, {
        show_alert: false,
        ignore_error: ApiErrors.NOT_LOGGED_IN,
      }),
    enabled: enabled,
    select: (data) => data?.data?.reward_user_account_status,
  });

  const { mutate } = useMutation({
    mutationKey: ['CreateAffiliatePdpShareLink'],
    mutationFn: async ({ product_id, shop_id }: CreateAffiliatePdpShareLinkInput) => {
      const { data } = await createAffiliatePdpShareLink({
        input: {
          product_id,
          shop_id,
        },
      });
      return data.createAffiliatePdpShareLink;
    },
  });

  return {
    is_activated_affiliate: user_account_status === 'ACTIVATED',
    isAffiliateStatusLoading,
    createAffiliateShareDeepLink: mutate,
  };
};
